var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"ForensicComponent",style:(("height: " + (_vm.clientHeight - 124) + "px;")),attrs:{"src":_vm.url,"frameborder":"0","scrolling":"yes"}})}
var staticRenderFns = []

export { render, staticRenderFns }